import { defineModule } from '@/core/define';
import { overridable } from '@/core/template-engine';

export default defineModule({
    id: 'deposit',
    requires: ['kyc'],
    routes: [
        {
            path: '/deposit',
            name: 'deposit',
            meta: { requiresAuth: true },
            component: overridable('DepositPage', () => import(/* webpackChunkName: "deposit" */ './views/DepositPage.vue'))
        },
        {
            path: '/deposit-record',
            name: 'dpRecord',
            meta: { requiresAuth: true },
            component: overridable('DepositRecordPage', () => import(/* webpackChunkName: "deposit" */ './views/DepositRecordPage.vue'))
        }
    ],
    contributes: {
        'nav.menu': [
            {
                key: 'deposit',
                order: 10,
                label: 'nav.deposit',
                children: [
                    { to: '/deposit', label: 'nav.deposit' },
                    { to: '/deposit-record', label: 'nav.depositRecord' }
                ]
            }
        ],
        'home.shortcuts': [
            { key: 'deposit', order: 10, icon: 'images/icons/shortcut-deposit.png', to: '/deposit' }
        ]
    }
});
